import { render, staticRenderFns } from "./LockedScreen.vue?vue&type=template&id=275cbb89&scoped=true&"
import script from "./LockedScreen.vue?vue&type=script&lang=ts&"
export * from "./LockedScreen.vue?vue&type=script&lang=ts&"
import style0 from "./LockedScreen.vue?vue&type=style&index=0&id=275cbb89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275cbb89",
  null
  
)

export default component.exports